<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataRentObjects")
    h1.title Channel Manager
    .sub-headline Hier können Sie die verknüpften Mietobjekte zu den verfügbaren Channels bearbeiten.

    .card.margin-top
      #main
        b-table(
                :data="rentObjects"
                default-sort-direction="adminSortOrder"
              )
          b-table-column(field='code', label='Code' width='40', centered, searchable, v-slot="props")
            b-tag(type="is-light")
              b {{ props.row.code }}
          b-table-column(field='rentObjectType.name' label='Typ' width='40', v-slot="props")
            b-field
              b-icon(:icon="props.row.rentObjectType.icon")
              p.icon-name {{props.row.rentObjectType.name}}
            p.sync(v-if="props.row.id === rentObject?.id" style="margin-left: 10px; color: #00d1b2; font-size: 12px; font-weight: bold;") Zuletzt geöffnet
          b-table-column(field='name' label='Name', v-slot="props")
            | {{ props.row.name }}
          b-table-column(label='iCal Feed', v-slot="props")
            input(type="text" :ref="'rentObject'+props.row.id" :value="`https://api.${settings.agencyPortalUrl}/rent-objects/${props.row.url}/ical-feed`")
            br
            b-button(type="is-light" @click="copyLink(props.row)") Link kopieren
          b-table-column(label='Channels', v-slot="props")
            .button-wrapper(v-for="channel in channels")
              b-button(:type="isRentObjectChannelAvailable(props.row, channel) ? 'is-success' : 'is-light'" @click="openChannel(props.row, channel)") {{channel.name}}

  b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='true' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          //- pre {{rentObjectChannel}}
          template(v-if="!rentObjectChannel")
            b-field(label="Externe ID" label-position="on-border")
              b-input(v-model="externalId")
            //- .breaker(v-if="!externalId")
            // TODO
            //- ChannelConfigEditor(v-if="!externalId" :configTemplate="configData" @updateConfigTemplate="(data) => updateConfigTemplate(data)")
            .button-wrapper.margin-top.right
              b-button(
                type="is-light",
                @click="reset()") Abbrechen
              b-button(
                type="is-primary",
                @click="saveConfig()") Speichern
          template(v-else)
            //- ChannelConfigEditor(:configTemplate="rentObjectChannel.configData" @updateConfigTemplate="(data) => updateConfigTemplate(data)")
            b-field(label="Externe ID" label-position="on-border")
              b-input(v-model="rentObjectChannel.externalId" disabled)
            .breaker
            .button-wrapper.margin-top
              b-button(
                type="is-success"
                @click="synchronize()"
                :disabled="!rentObjectChannel"
                icon-left="cog") Preise Synchronisieren
            .spacer.sm
            .button-wrapper
              b-button(
                type="is-success"
                @click="synchronizePictures()"
                :disabled="!rentObjectChannel"
                icon-left="cog") Bilder Synchronisieren
              b-checkbox(
                v-model="deletePicturesPrior"
                :disabled="!rentObjectChannel") Alle Bilder vorher löschen
            .spacer.sm
            .button-wrapper
                b-button(
                type="is-danger"
                @click="deleteRentObjectChannel()"
                icon-left="close") Channel Verbindung löschen
            
            template(v-if="channelImages.traumferienwohnungen.length")
                .spacer.md
                label Klicken Sie auf ein Bild, um es auf traumferienwohnungen zu löschen
                .channel-images
                    .channel-image(v-for="image in channelImages.traumferienwohnungen" @click="deleteTraumferienwohnungenImage(image.id)")
                        img(:src="image.url")

</template>

<script> 
import ChannelConfigEditor from '@/components/atoms/ChannelConfigEditor.vue';

export default {
   components: {
    ChannelConfigEditor
  },
  data() {
    return {
      settings: null,
      externalId: null,
      channels: [],
      rentObjectChannel: null,
      rentObject: null,
      channel: null,
      configData: [],
      isModalActive: false,
      deletePicturesPrior: true,
      channelImages: {
        traumferienwohnungen: [],
      },
    };
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all;
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    }
  },
  methods: {
    async saveConfig() {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectChannels/create", {externalId: this.externalId, rentObjectId: this.rentObject.id, configData: this.configData, channelId: this.channel.id});
      this.reset();
      this.$store.dispatch("rentObjects/findAllWithChannel");
      loadingComponent.close();
    },
    deleteRentObjectChannel() {
      this.isModalActive = false;
      this.$buefy.dialog.confirm({
        title: "Verbindung löschen",
        message: `Sind Sie sicher, dass Sie diese <b>${this.channel.name}</b> Verbindung zu <b>${this.rentObject.name}</b> löschen möchten?`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            const loadingComponent = this.$buefy.loading.open();
            await this.$store.dispatch("rentObjectChannels/delete", {
              id: this.rentObjectChannel.id,
            });
            this.$store.dispatch("rentObjects/findAllWithChannel");
            loadingComponent.close();
          } catch (e) {
            // Erstmal nichts hier
          }
        },
      });
    },
    isRentObjectChannelAvailable(rentObject, channel) {
      return rentObject.rentObjectChannels.find(c => c.channelId === channel.id);
    },
    openChannel(rentObject, channel) {
      this.configData = channel.configTemplate;
      this.rentObject = rentObject;
      this.channel = channel;
      this.rentObjectChannel = rentObject.rentObjectChannels.find(c => c.channelId === channel.id); 
      this.getPictures();
      this.isModalActive = true;
    },
    copyLink(rentObject) {
      this.$refs['rentObject'+rentObject.id].select();
      this.$refs['rentObject'+rentObject.id].setSelectionRange(0, 99999);
      document.execCommand("copy");
    },
    async synchronize() {
      const loadingComponent = this.$buefy.loading.open();
      const report = await this.$store.dispatch("rentObjectChannels/synchronize", { id: this.channel.id, rentObjectId: this.rentObject.id });
      this.$buefy.toast.open(`Es wurden ${report.priceUpdatedCount >= 0 ? report.priceUpdatedCount : '-FEHLER-'} Preise aktualisiert.`)
      loadingComponent.close();
    },
    async synchronizePictures() {
      const loadingComponent = this.$buefy.loading.open();
      const report = await this.$store.dispatch("rentObjectChannels/synchronizePictures", { id: this.channel.id, rentObjectId: this.rentObject.id, deletePicturesPrior: this.deletePicturesPrior });
      this.$buefy.toast.open(`Es wurden ${report.imageUpdatedCount >= 0 ? report.imageUpdatedCount : '-FEHLER-'} Bilder aktualisiert.`)
      loadingComponent.close();
    },
    async deleteTraumferienwohnungenImage(id) {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectChannels/deleteTraumferienwohnungenImage", { id: this.channel.id, rentObjectId: this.rentObject.id, imageId: id });
      this.getPictures();
      loadingComponent.close();
    },
    async getPictures() {
        this.channelImages = {
            traumferienwohnungen: [],
        };
      const images = await this.$store.dispatch("rentObjectChannels/getPictures", { id: this.channel.id, rentObjectId: this.rentObject.id });
      this.channelImages = {
        traumferienwohnungen: images.traumferienwohnungen.filter(i => i.activated),
      };
    },
    updateConfigTemplate(data) {
      this.configData = data;
    },
    reset() {
      this.isModalActive = false;
      this.externalId = null;
    }
  },
  async mounted() {
    this.$store.dispatch("rentObjects/findAllWithChannel");
    this.$store.dispatch("rentObjectTypes/findAll");
    this.settings = await this.$store.dispatch("settings/find");
    this.channels = await this.$store.dispatch("channels/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
.channel-images {
    display: flex;
    flex-wrap: wrap;
    .channel-image img {
        width: 60px;
        height: 60px;
        object-fit: contain;
        margin: 5px;
    }
}
.channel-image {
    position: relative;
}
.channel-image:hover::after {
    content: "Löschen";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-weight: bold;
    font-size: 12px;
    color: white;
    z-index: 99;
}
</style>